export default __webpack_public_path__ + "static/media/Portfolio.ca3760d3.pdf";